var _style, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 224 180",
    style: {
      enableBackground: "new 0 0 224 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000097478831803047637330000008464071107095144580_);}\n\t.st1{clip-path:url(#SVGID_00000023985018348096794070000016945281105783614625_);}\n\t.st2{fill:url(#SVGID_00000057867455474156802110000004296204124704940945_);}\n\t.st3{fill:url(#SVGID_00000011714946547010742040000017730775789834717349_);}\n\t.st4{fill:url(#SVGID_00000139972470166545843130000007672365516268804005_);}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#D4D6DC;}\n\t.st7{fill:url(#SVGID_00000138532059837098036210000009919933522998145695_);}\n\t.st8{fill:url(#SVGID_00000169544073375248005430000004361507828773394566_);}\n\t.st9{fill:#BFC8D6;}\n\t.st10{fill:#475B80;}\n\t.st11{opacity:0.3;}\n\t.st12{opacity:0.3;fill:url(#SVGID_00000176018343408518094420000011289999451555716995_);enable-background:new    ;}\n\t.st13{opacity:0.3;fill:url(#SVGID_00000070834386428536070470000000049523666425599122_);enable-background:new    ;}\n\t.st14{opacity:0.3;fill:url(#SVGID_00000075164587623913954870000000405185700908410794_);enable-background:new    ;}\n\t.st15{fill:url(#SVGID_00000101796183002659904070000007858611845193707181_);}\n\t.st16{fill:url(#SVGID_00000096044396963759207150000005959322225876264866_);}\n\t.st17{opacity:0.3;fill:#CCF5F5;enable-background:new    ;}\n\t.st18{fill:#CCF5F5;}\n\t.st19{opacity:0.3;fill:url(#SVGID_00000092454325538008091490000003175342275536114347_);enable-background:new    ;}\n\t.st20{opacity:0.3;fill:url(#SVGID_00000097499408820851710270000009383129204752033448_);enable-background:new    ;}\n\t.st21{opacity:0.3;fill:url(#SVGID_00000155860674250656541760000015291908328797322406_);enable-background:new    ;}\n\t.st22{opacity:0.3;fill:url(#SVGID_00000164480388678806579170000009784843999066686646_);enable-background:new    ;}\n\t.st23{fill:url(#SVGID_00000041975381877791971260000008462051763732254865_);}\n\t.st24{fill:url(#SVGID_00000077308376541285579420000016467175009164520377_);}\n\t.st25{fill:url(#SVGID_00000049921567658577135530000004351241615266833554_);}\n\t.st26{fill:url(#SVGID_00000117652259846834694210000015050796216338198413_);}\n\t.st27{fill:url(#SVGID_00000041984639986736539210000012207010316547203250_);}\n\t.st28{opacity:0.4;fill:url(#SVGID_00000002369611402142432150000012541565547647642255_);enable-background:new    ;}\n\t.st29{fill:url(#SVGID_00000163763892637860948480000004681126002383939731_);}\n\t.st30{fill:url(#SVGID_00000052073816501455671120000016449970940485358737_);}\n\t.st31{fill:url(#SVGID_00000079485546727965961420000013264475047912188822_);}\n\t.st32{fill:none;}\n\t.st33{fill:url(#SVGID_00000114069265563034520200000015156199595698075265_);}\n\t.st34{fill:url(#SVGID_00000112609036800775746330000007953442998123966118_);}\n\t.st35{fill:url(#SVGID_00000176749377232222912860000017737300575881595550_);}\n\t.st36{fill:url(#SVGID_00000118385225205784499930000014931325369521745032_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 224,
    height: 180
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128444848314783325640000004720605786444371895_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000128444848314783325640000004720605786444371895_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000181769473081728619960000017817884347350579612_",
    x: 26,
    y: 10,
    width: 172,
    height: 160
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124868979539830001220000001614738091369952139_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000181769473081728619960000017817884347350579612_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000124868979539830001220000001614738091369952139_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000941205316793474230000008710214288075876481_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.4256,
    y1: 138.3017,
    x2: 75.0372,
    y2: 135.7447,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3DB39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#28807A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000941205316793474230000008710214288075876481_)"
    },
    d: "M155.9,54.2L95.2,79.8 c-0.8,0.3-1.8-0.2-2.2-1.1L74.8,35.8c-0.3-0.7,0-1.5,0.7-1.8l61.4-24c0.8-0.3,1.8,0.2,2.2,1.1l17.6,41.3 C156.9,53.2,156.6,53.9,155.9,54.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068651431964156279790000011322857088930400695_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.0161,
    y1: 127.4652,
    x2: 151.9165,
    y2: 142.7839,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3E7EC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068651431964156279790000011322857088930400695_)"
    },
    d: "M155.4,54.9L95.8,79.4 c-0.8,0.3-1.7-0.1-2-1l-6.9-21.1l-6.8-20.2l61.5-23c0.4-0.2,0.9,1.7,1.1,2.1L155.4,54.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031895526397556184800000011562643268122732475_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.0152,
    y1: 129.8115,
    x2: 85.7327,
    y2: 149.2244,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3E7EC"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031895526397556184800000011562643268122732475_)"
    },
    d: "M155.1,55.7l-49.9,20.2l-7.9,2.9 l-1.9,0.7l-0.3,0.1c-0.3,0.1-0.6,0.1-0.8,0c0,0,0,0,0,0c-0.1,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.3-0.2-0.4-0.4 c-0.1-0.2-0.2-0.3-0.3-0.5l-5.2-18.1l-6.2-21.1c-0.1-0.3,0-0.6,0.2-0.8c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1l0.5-0.2 l2-0.7l57.8-19.7c0.2-0.1,0.5-0.1,0.7,0c0.6,0.1,1.1,0.5,1.2,1.1l0,0.1l6.4,21.9l4.1,14.1L155.1,55.7z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M155.3,55.6l-0.2,0.1l-49.9,20.2l-5,2l-4.2,1.4l-0.2,0.1l-0.3,0.1l-0.4,0.1c-0.2,0.1-0.5,0.1-0.7,0 c0,0-0.1,0-0.1-0.1c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.2-0.3-0.3-0.5l-2.7-10.4L82.7,39 c-0.1-0.4,0.1-0.8,0.5-0.9l1.4-0.5l59-18.4l0.3-0.1c0.2,0,0.3-0.1,0.5,0c0.6,0,1.2,0.5,1.4,1.1l7.7,29.1l1.5,5.6L155.3,55.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M91.6,73.6l-11.4-32l-0.2-4.4l6.5,19.4L91.6,73.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072986563837157643200000009781620117694249149_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.5823,
    y1: 137.4168,
    x2: 84.8073,
    y2: 135.0991,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3DB39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1071,
    style: {
      stopColor: "#41C9B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7ACA94"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072986563837157643200000009781620117694249149_)"
    },
    d: "M84.7,37.6c0,0,0-0.1,0.1-0.1 c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.4-0.5,0.7-0.6l20.3-7.7l28.4-10.7l-0.3-1.2c-0.2-1.1,0.3-2.1,1.3-2.5l7.7-2.9 c0.5-0.2,1,0.1,1.1,0.6l0.5,2.1l3.6-1.4c0.8-0.3,1.7,0.2,1.9,1.1l8.7,38.5c0.2,0.7-0.2,1.4-0.9,1.7l-2.7,1.1l-0.2,0.1 l-49.9,20.2l-5,2l-4.6,1.9c-0.4,0.2-0.8,0.1-1.2-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0,0,0c-0.3-0.2-0.5-0.5-0.6-0.9l-9.1-40.2 C84.5,38.2,84.5,37.9,84.7,37.6z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.2,13.8C143.2,13.8,143.2,13.7,143.2,13.8L143.2,13.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.1,13.7c0,0,0,0.1,0,0.1C143.1,13.8,143.1,13.8,143.1,13.7C143.1,13.7,143.2,13.7,143.1,13.7 C143.2,13.7,143.2,13.8,143.1,13.7C143.1,13.7,143.1,13.7,143.1,13.7C143.1,13.7,143.1,13.7,143.1,13.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143,13.9C143,13.9,143,13.9,143,13.9C143,13.9,143,13.9,143,13.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.5,13.8C142.5,13.8,142.5,13.8,142.5,13.8C142.5,13.8,142.5,13.8,142.5,13.8 C142.5,13.8,142.5,13.8,142.5,13.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.1,15.1c0,0,0,0.1,0.1,0.1C139.2,15.1,139.2,15.1,139.1,15.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.7,16.6C136.7,16.6,136.6,16.5,136.7,16.6C136.6,16.6,136.6,16.6,136.7,16.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.4,15.1C140.4,15.1,140.4,15.1,140.4,15.1C140.4,15.1,140.4,15.1,140.4,15.1L140.4,15.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M136.5,16.7c0,0,0-0.1,0-0.1C136.5,16.6,136.5,16.7,136.5,16.7c0.1-0.1,0-0.1,0.1-0.1v0 c0-0.1,0.1,0,0.1-0.1c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0,0v0v0c0,0.1,0,0,0,0.1c0,0,0-0.1,0.1-0.1c0,0.1,0,0,0,0.1h-0.1 c0.1,0.1,0,0,0.1,0.1c0.1,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0-0.1,0.1,0.1,0.1,0c0-0.1,0-0.1,0-0.1l0,0.1c0.1,0,0-0.1,0.1-0.1 c0,0,0,0,0,0.1c0.1,0.1,0-0.1,0-0.1l0,0.1c0,0,0.1-0.1,0.1-0.1c0,0,0,0.1,0,0.1c0.1-0.1,0.1-0.1,0.2,0v-0.1l0,0c0,0,0,0,0-0.1 c0,0,0,0,0,0.1c0-0.1,0.1-0.1,0.1-0.1v0c0.1,0,0-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2,0c0-0.1,0.1,0,0.1-0.1c0.1,0,0.1,0.1,0.1,0.1 c0,0,0-0.1,0-0.1l0,0.1V16L138,16v0l0,0c0,0,0.1,0,0.1,0.1l0.1-0.1c0,0,0,0,0,0.1c0-0.1,0,0.1,0.1,0c0,0,0,0,0-0.1 c0,0,0.1,0,0.1,0V16c0.1,0,0.1-0.1,0.2-0.1c0,0-0.1-0.1,0-0.1h0c0-0.1,0,0,0-0.1c0,0,0.1,0.1,0,0.1l0,0c0,0,0,0,0,0.1 c0-0.1,0.1,0.1,0.1,0v0c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.1c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0,0.1,0.1,0,0.1,0.1 c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0,0s0,0,0,0c0-0.1,0.2,0.1,0.2-0.1l0-0.1c0,0,0,0.1,0,0.1c0-0.1,0.1,0,0.1-0.1 c0.1,0.1,0.1-0.1,0.2,0l0,0c0,0,0,0,0,0c0,0,0,0,0-0.1c0.1-0.1,0.2-0.1,0.4-0.1c0.1,0-0.1-0.2,0.1-0.1v0.1 c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0.1c0,0,0-0.1,0.1,0v0c0,0,0.1,0,0-0.1c0.1,0,0.1-0.1,0.1,0 c0-0.1,0.1,0,0-0.1c0,0.1,0.1,0.1,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0-0.1c0.1,0.1,0.1-0.1,0.1,0c0.1-0.1,0.1-0.1,0.2-0.2 c0,0.1-0.1,0,0,0.1c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0.1c0.1-0.1,0.1,0,0.1-0.1v0c0,0,0,0,0,0v0c0-0.1,0-0.1,0-0.2 c0,0.1,0.1,0,0.1,0.2c0,0,0,0,0-0.1c0,0,0,0,0,0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0.1c0-0.1,0-0.1,0-0.1v0c0.1,0,0.1-0.1,0.1-0.1 c0,0.1,0,0,0.1,0.1l0,0l0,0c0,0,0-0.1,0.1-0.1v0l0.1,0l0,0c0-0.1,0-0.1,0-0.1c0,0,0,0,0.1,0c0,0,0-0.1,0-0.1c0,0,0,0.1,0,0.1 c0-0.1,0.1,0,0.1-0.1c0,0,0,0.1,0,0.1v-0.1c0,0,0,0,0,0.1c0,0-0.1-0.1,0-0.1c0,0,0,0,0,0c0.1,0,0.1-0.1,0.1-0.1c0,0.1,0,0,0,0.1 c0.1,0,0.1-0.1,0.1-0.1c0-0.1,0.1,0,0.1,0v0.1c0.1,0,0.1-0.1,0.1-0.1v0c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1c0.1,0.1,0.1-0.1,0.2,0v0 l0.1-0.1c0-0.1,0,0-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0,0.1,0.1,0.1c0,0,0,0,0-0.1c0.1,0.1,0-0.1,0-0.1v0c0,0,0-0.1,0-0.1 c0,0.1,0,0,0,0.1c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0.1,0.1,0,0.1,0h0.1h0c0-0.1,0.1-0.1,0.1-0.1c0,0.1,0,0.1,0,0.1 c0,0,0,0,0,0.1c0-0.1,0.1,0,0-0.1c0,0,0,0,0,0.1c0,0,0,0,0-0.1c0-0.1,0.1,0.1,0.1-0.1c0-0.1,0-0.1,0-0.2c0,0,0,0.1,0,0.1 c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1c0,0,0-0.1,0-0.1c0,0,0,0.1,0,0.1c0,0,0-0.1,0-0.1c0,0,0,0.1,0,0.1c0,0,0.1-0.1,0-0.1h0l0,0.1 c0,0.1,0,0-0.1,0v0c-0.1-0.1-0.1,0-0.1,0.1l0-0.1v0.1c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0v0c0,0,0-0.1,0-0.1 c-0.1,0,0,0.1-0.1,0c0,0.1,0,0.1,0,0.1l-0.1-0.1l0,0.1c0,0,0,0,0,0c0,0.1,0,0,0,0.1c-0.1-0.1-0.1,0.1-0.1,0c0,0.1,0,0,0,0.1 c-0.1-0.1,0,0-0.1,0c0-0.1,0,0,0-0.1c0,0.1-0.1,0-0.1,0c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0.1,0,0.1,0,0.1 c0-0.1,0-0.1,0-0.1h0c0,0,0,0,0,0.1l0-0.1c0,0,0,0.1-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0-0.1,0-0.1s0,0,0,0V14c0,0,0,0,0,0.1 c0,0,0,0,0-0.1h0c0,0-0.1,0-0.1-0.1c0,0,0,0.1,0,0.1c0,0,0,0-0.1-0.1c0,0,0,0,0,0.1l0,0c0,0-0.1,0,0,0.1c0,0.1-0.1,0-0.1,0.1v0 c0,0-0.1,0-0.1,0.1c0,0,0,0,0-0.1c0,0,0,0.1-0.1,0c0-0.1,0,0,0,0c0,0-0.1,0-0.1,0c0-0.1-0.1-0.1-0.1,0l0,0c0,0,0,0-0.1,0l0-0.1 c-0.1-0.1-0.1,0.2-0.1,0.1c0,0.1,0.1,0,0.1,0.1c0,0-0.1-0.1-0.1-0.1c-0.1,0,0,0.1-0.1,0.1c0,0,0.1,0.1,0,0.1 c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1v0c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1c-0.1,0-0.1,0-0.1,0l0,0c-0.1,0,0,0.1,0,0.1 c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0-0.1c0,0.1-0.1,0-0.1,0v0c0,0,0,0,0,0l0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0-0.1,0 c0.1,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0,0,0.1,0,0.1c0,0,0-0.1,0-0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0h0c0,0,0,0,0,0.1 c0,0,0,0,0,0c0,0.1-0.1-0.1-0.1,0c0,0,0-0.1-0.1-0.1c0,0.1-0.1,0-0.1,0c0,0.1,0,0,0,0.1l0.1-0.1v0.1c0,0,0-0.1,0,0 c0,0.1,0,0,0,0.1c-0.1-0.1,0,0.1-0.1,0l-0.1-0.1c-0.1,0-0.1,0.1-0.1,0.1h0c0,0.1,0,0,0,0.1c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0.1 l-0.1,0c-0.1,0,0,0.1-0.1,0.1c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0.1-0.1,0c0,0,0,0.1,0,0.1v0c0,0,0,0,0,0.1 c-0.1-0.1-0.1,0.1-0.2,0c0,0-0.1,0.1-0.1,0.1v0c-0.1,0,0,0.1,0,0.1c-0.1-0.1,0-0.1,0-0.1c-0.1-0.1-0.1,0-0.1,0 c0,0,0,0.1-0.1,0.1c0,0,0,0,0,0c0,0.1,0,0.1-0.1,0.1c0-0.1,0,0,0-0.1c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1-0.1l0,0c-0.1-0.1,0,0-0.1,0 v0c0,0,0,0.1-0.1,0.1v0c0,0.1,0,0-0.1,0l0-0.1c0,0,0,0.1-0.1,0.1c0-0.1,0-0.1,0-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0 c0,0.1,0,0.1-0.1,0.1c-0.1-0.1-0.1,0-0.2-0.1c0,0.1-0.1,0-0.2,0.1c0.1,0.1,0,0,0,0.1c0,0,0,0,0,0l-0.1-0.1c0,0,0,0,0-0.1 c0,0,0-0.1-0.1-0.1c0,0,0,0.1,0,0.1l0.1,0.1c0,0.1-0.1-0.1-0.1,0v-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0,0-0.1c-0.1,0-0.1,0.2-0.2,0.1 v0c0,0,0,0.1,0,0v0c0,0,0,0.1,0,0.1v0c-0.1,0-0.1,0.1-0.1,0.2c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0.1-0.1,0.2 c-0.1-0.1-0.1,0-0.2,0c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0s-0.1,0-0.1,0l0,0.1c-0.1-0.1-0.1,0.1-0.2,0c0,0,0,0,0,0.1l0-0.1 c-0.1,0-0.1,0-0.1,0v-0.1c0,0,0,0.2,0,0.2l0-0.1c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0-0.1c0,0-0.1,0-0.1,0.1c0-0.1-0.1,0-0.1,0.1 l0-0.1c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1-0.1,0.1v0c0,0,0,0,0,0.1s-0.1,0-0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0 c-0.1,0,0,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0-0.1-0.1-0.1-0.1-0.1c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0h0 c0,0,0,0-0.1,0c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0.1,0,0c0,0,0,0.1,0,0.1c-0.1-0.1-0.1-0.1-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2 c0,0,0,0,0,0v0c0,0-0.1,0-0.1,0.1c-0.1,0,0-0.1-0.1-0.1v0c-0.1-0.1-0.1,0.2-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.3,0.1 c0,0,0,0,0,0.1l0-0.1v0.1c0,0.1-0.1-0.1-0.1,0l0,0c0,0-0.1,0.1-0.1,0c0,0,0,0.1,0,0v0l0,0.1c-0.1,0-0.1-0.1-0.1-0.1 c0,0,0,0.1,0,0.1c0,0,0,0,0,0v0c0,0.1,0.1,0.2,0.1,0.2v-0.1l0,0h0c0,0,0,0,0,0c0,0,0,0,0,0.1v-0.1c0,0,0,0.1,0.1,0.1 c0-0.1-0.1-0.1,0-0.1c0,0,0,0.1,0.1,0c0,0,0,0,0,0.1c0,0,0,0,0-0.1c0,0.1,0.1,0,0.1,0.1c0,0,0-0.1,0-0.1c0,0.1,0.1,0,0.1,0.1 c0-0.1,0.1-0.1,0.1-0.1v0c0,0,0,0,0.1,0c0-0.1,0-0.1,0-0.2c0.1,0.1,0,0.1,0.1,0.2c0-0.1,0-0.1,0-0.1c0,0,0,0,0.1,0.1 c0-0.1,0,0,0-0.1c0.1,0,0.1,0.1,0.1,0.1C136.5,16.7,136.5,16.7,136.5,16.7z M137.1,16.3C137.1,16.3,137.1,16.2,137.1,16.3 L137.1,16.3z M136.9,15.9C136.9,15.9,136.9,15.9,136.9,15.9C136.9,16,136.9,16,136.9,15.9C136.9,16,136.9,16,136.9,15.9 C136.9,16,136.9,16,136.9,15.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.7,14.1C142.7,14,142.7,14,142.7,14.1C142.6,14,142.6,14,142.7,14.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.5,14.5L141.5,14.5C141.5,14.5,141.5,14.5,141.5,14.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.4,14.5C141.5,14.5,141.5,14.5,141.4,14.5C141.5,14.5,141.4,14.5,141.4,14.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.1,13.8C143.1,13.9,143.1,13.9,143.1,13.8L143.1,13.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.9,13.9C143,13.9,143,13.9,142.9,13.9L142.9,13.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.9,13.9C142.9,13.9,143,14,142.9,13.9L142.9,13.9C143,14,142.9,13.9,142.9,13.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.7,13.8L142.7,13.8C142.7,13.8,142.7,13.7,142.7,13.8C142.6,13.7,142.7,13.8,142.7,13.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.5,13.8C142.6,13.8,142.5,13.8,142.5,13.8C142.5,13.8,142.5,13.8,142.5,13.8z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.8,14.1L141.8,14.1C141.7,14.1,141.8,14.1,141.8,14.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.7,14.4L141.7,14.4L141.7,14.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.5,14.1L141.5,14.1L141.5,14.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.2,14.7L140.2,14.7C140.2,14.7,140.2,14.6,140.2,14.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.7,14.9C139.6,14.9,139.6,14.9,139.7,14.9C139.6,14.9,139.7,15,139.7,14.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.7,15.5C143.7,15.5,143.7,15.5,143.7,15.5L143.7,15.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.6,15.4C143.6,15.5,143.6,15.5,143.6,15.4C143.6,15.5,143.6,15.5,143.6,15.4 C143.6,15.4,143.6,15.5,143.6,15.4C143.6,15.5,143.7,15.5,143.6,15.4L143.6,15.4C143.6,15.5,143.6,15.5,143.6,15.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.2,16.3C141.2,16.3,141.2,16.3,141.2,16.3C141.2,16.3,141.2,16.3,141.2,16.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.1,16.2C142,16.3,142.1,16.3,142.1,16.2L142.1,16.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142,16.3C142,16.3,142,16.3,142,16.3C141.9,16.3,141.9,16.3,142,16.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.6,17.3C139.6,17.3,139.6,17.2,139.6,17.3C139.6,17.2,139.6,17.2,139.6,17.3 C139.6,17.2,139.6,17.2,139.6,17.3C139.6,17.2,139.6,17.2,139.6,17.3c0-0.1,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1s0,0,0,0 c0,0,0,0,0,0v0c0,0,0,0,0,0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0.1h0c0,0.1,0,0,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1 c0-0.1,0.1,0.1,0.1,0c0,0,0-0.1,0-0.1v0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0 c0,0,0.1,0,0.1,0v0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0.1,0,0.1-0.1,0.1,0c0-0.1,0.1,0,0-0.1 c0,0,0,0,0.1,0.1v-0.1l0,0v-0.1l0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0l0-0.1c0,0,0,0,0,0c0-0.1,0,0,0,0v0c0,0,0,0,0.1,0v0 c0,0,0.1,0,0.1-0.1c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0-0.1c0,0,0,0,0,0.1v0v0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1 c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1c0,0,0,0,0,0.1c0,0,0,0,0.1-0.1l0,0c0,0,0,0,0,0c0-0.1,0.1,0.1,0.1,0l0-0.1c0,0,0,0,0,0 c0-0.1,0.1,0,0.1-0.1c0.1,0.1,0.1,0,0.1,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0.1-0.1,0.2,0,0.2,0c0,0,0-0.1,0-0.1v0.1 c0-0.1,0.1,0,0.1-0.1v0c0,0,0,0,0,0s0,0,0,0c0,0,0-0.1,0,0c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0-0.1c0,0.1,0.1,0,0.1,0 c0,0,0,0,0,0c0,0,0,0,0-0.1c0.1,0.1,0-0.1,0.1,0c0-0.1,0.1-0.1,0.1-0.1c0,0.1,0,0,0,0.1c0,0,0-0.1,0.1-0.1v0c0,0,0.1,0,0.1-0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0,0.1,0,0,0.1,0.1v0c0,0,0,0,0,0c0,0,0-0.1,0-0.1v0c0,0,0-0.1,0-0.1v0 c0,0,0-0.1,0.1-0.1c0,0.1,0,0,0,0.1v0l0,0c0,0,0-0.1,0,0v0l0,0h0c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0.1c0,0,0,0,0-0.1 v0v0c0,0,0,0,0,0c0,0,0-0.1,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0,0,0,0v0c0,0,0,0,0.1-0.1v0 c0,0,0,0,0.1,0c0,0,0,0,0,0c0.1,0.1,0.1-0.1,0.1,0v0l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1v0c0,0,0-0.1,0,0v0 c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0-0.1,0-0.1v0c0,0,0,0,0,0h0c0-0.1,0,0,0-0.1c0,0.1,0,0,0,0.1l0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0-0.1,0.1,0,0.1,0c0,0,0-0.1,0-0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0s0,0,0,0c0,0,0-0.1,0,0c0,0,0,0,0,0.1 c0,0,0,0,0-0.1c0,0,0,0,0,0.1c0,0,0,0,0-0.1v0c0,0,0,0,0,0c0-0.1,0,0-0.1,0v-0.1v0.1c0,0,0,0,0-0.1c0,0,0,0,0,0v0c0,0,0,0,0,0 c0,0,0,0.1-0.1,0c0,0,0,0,0,0.1l-0.1-0.1v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0-0.1,0,0,0,0c0,0,0,0,0-0.1 c0,0.1,0,0,0,0c0,0.1,0,0,0,0.1c0,0-0.1,0-0.1,0c0,0.1,0,0.1,0,0.1c0,0,0,0,0-0.1c0,0,0,0,0,0v0c0,0,0,0.1-0.1,0 c0,0,0.1,0.1,0,0.1c0,0,0-0.1,0-0.1s0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0.1c0,0.1-0.1,0-0.1,0c0,0,0,0,0,0.1l0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0h0v0 c-0.1,0,0,0.1-0.1,0c0,0,0,0,0,0.1c0,0-0.1-0.1-0.1-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0-0.1-0.1,0-0.1v0v0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0-0.1,0,0c0,0,0,0,0-0.1c0,0-0.1,0-0.1,0v0l0,0c0,0,0,0,0,0 c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0s0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1l0,0v0.1l0,0c0,0,0,0,0,0c0,0,0,0-0.1,0l0-0.1 c0,0,0,0.1-0.1,0.1h0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1l0,0c0,0,0,0.1,0,0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0v0 c0,0,0,0,0,0.1c-0.1-0.1-0.1,0-0.1,0c0,0,0,0-0.1,0s0,0.1,0,0.1c0,0,0,0,0,0c0-0.1,0,0-0.1,0c0,0,0,0-0.1,0.1c0,0.1,0,0.1,0,0.1 c0,0,0,0,0-0.1c0,0,0,0.1,0,0.1c0,0,0,0-0.1-0.1h0c0,0,0,0,0,0v0c0,0,0,0.1,0,0.1c0,0.1,0,0,0,0l0-0.1c0,0,0,0.1,0,0.1 c0,0,0-0.1,0-0.1l0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0-0.1-0.1,0-0.1-0.1c0,0.1-0.1,0-0.1,0c0.1,0.1,0,0,0,0.1c0,0,0,0,0,0l-0.1,0 c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0l0,0c0,0.1-0.1-0.1-0.1,0v0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1v0 c0,0,0,0,0,0v0c0,0,0,0,0,0v0c-0.1,0,0,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0.1-0.1,0.1c-0.1-0.1-0.1,0-0.1,0 c0,0,0,0,0,0.1c0,0,0,0.1,0,0c0-0.1,0,0-0.1,0l0,0.1c-0.1-0.1-0.1,0.1-0.1,0c0,0,0,0,0,0.1v0c0,0-0.1,0-0.1,0v0c0,0,0,0.1,0,0.1 l0-0.1c0,0-0.1,0-0.1,0v0c0,0-0.1,0,0,0.1c0-0.1,0,0-0.1,0v0c0,0.1,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0.1 c0,0,0,0-0.1,0c0,0,0,0.1,0,0v0c0,0,0,0.1-0.1,0v0c0,0,0,0,0,0c0,0,0,0,0-0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1l0,0c0,0,0,0,0,0c0,0,0,0,0,0.1 c0,0,0-0.1,0,0v0c-0.1-0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0.1l0,0v0.1c0,0-0.1-0.1-0.1,0v0c0,0,0,0,0,0v0v0 l0,0.1c0,0,0-0.1-0.1-0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0v0c0,0.1,0,0.1,0.1,0.1v0l0,0h0c0,0,0,0,0,0c0,0,0,0,0,0v-0.1 c0,0,0,0.1,0,0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0v0c0,0,0,0,0-0.1c0,0,0,0,0.1,0v-0.1c0,0.1,0,0,0.1,0.1 C139.5,17.3,139.5,17.4,139.6,17.3C139.5,17.3,139.5,17.3,139.6,17.3L139.6,17.3C139.5,17.3,139.6,17.3,139.6,17.3 C139.6,17.3,139.6,17.3,139.6,17.3C139.6,17.3,139.6,17.3,139.6,17.3C139.6,17.3,139.6,17.3,139.6,17.3 C139.6,17.3,139.6,17.3,139.6,17.3C139.6,17.3,139.6,17.3,139.6,17.3C139.6,17.2,139.6,17.3,139.6,17.3z M140,17 C140,17,140,17,140,17C140,17,140,17,140,17C140,17,140,17,140,17z M140,17C140,17,140,17,140,17C140,17,140,17,140,17 C140,17,140,17,140,17z M139.9,16.8C139.9,16.8,139.9,16.8,139.9,16.8L139.9,16.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.3,15.6C143.3,15.6,143.3,15.6,143.3,15.6C143.3,15.6,143.3,15.6,143.3,15.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.5,15.6C143.5,15.6,143.5,15.6,143.5,15.6C143.5,15.6,143.5,15.6,143.5,15.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.3,15.5C143.4,15.5,143.3,15.5,143.3,15.5C143.3,15.4,143.4,15.5,143.3,15.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M142.8,15.9L142.8,15.9L142.8,15.9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.8,16L141.8,16C141.9,16,141.9,16,141.8,16z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.5,16.2C141.5,16.2,141.5,16.2,141.5,16.2C141.5,16.2,141.5,16.2,141.5,16.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M143.7,15.5l-3.2,1h0L143.7,15.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000079480681902089494110000010650595446723380635_",
    cx: -298.8115,
    cy: 488.7439,
    r: 0.9999,
    gradientTransform: "matrix(-21.0575 -28.5451 -16.9649 12.5149 2133.3408 -14580.5918)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7EB2D6",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1289,
    style: {
      stopColor: "#73ACCA",
      stopOpacity: 0.6098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4469,
    style: {
      stopColor: "#5EA1B3",
      stopOpacity: 0.3871
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7448,
    style: {
      stopColor: "#5199A5",
      stopOpacity: 0.1786
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C97A0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079480681902089494110000010650595446723380635_)"
    },
    d: "M168.5,100.5c0,0-0.9,2.3-7.3,0.5 c-6.4-1.9-40.8-12.3-43.8-17.8c-3-5.5-17.2-55-7.6-60.1c9.7-5.1,40,23.4,43.4,28.1S168.5,100.5,168.5,100.5z"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198,33c0.3,5.5-18.2,86.6-29.6,113.6c-3.6,8.5-6.9,13.1-6.9,13.1l-67.3,2.9c0,0,10.3-10.9,17.8-34.5 c6.3-19.8,23.8-88.2,23.8-88.2L198,33z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M164.1,45.3l-24.2,3l1-3.4l24.2-3L164.1,45.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M148.9,52.4l-10.7,1.3l0.9-3l10.7-1.2L148.9,52.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M159.3,63.9L134.6,66c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C159.5,63.7,159.4,63.8,159.3,63.9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M135.8,64l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L135.8,64z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M136.6,63.9l0.2-0.6l0.3,0l-0.2,0.6L136.6,63.9z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M188.1,61.3l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C188.3,61.2,188.2,61.3,188.1,61.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M164.6,61.5l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L164.6,61.5 z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M165.9,59.7c0.1-0.3,0.3-0.6,0.7-0.7c0.4,0,0.4,0.2,0.3,0.6c-0.1,0.3-0.2,0.4-0.3,0.5 c0.1,0.1,0.2,0.2,0.1,0.5s-0.4,0.7-0.8,0.8c-0.4,0-0.5-0.3-0.4-0.6l0.3,0c0,0.2,0,0.3,0.2,0.3c0.2,0,0.3-0.2,0.4-0.4 c0.1-0.2,0-0.4-0.2-0.3h-0.1l0.1-0.3h0.1c0.2,0,0.3-0.1,0.3-0.3c0.1-0.2,0-0.3-0.2-0.3c-0.2,0-0.3,0.2-0.3,0.3L165.9,59.7z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M166.9,61.3l0.2-0.6l0.3,0l-0.2,0.6L166.9,61.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M185.7,69.1l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C185.9,69,185.8,69.1,185.7,69.1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M162.3,69.2l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L162.3,69.2 z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M163.8,69.1l0.2-0.5l-0.7,0.1l0.1-0.4l1.1-1.4l0.3,0l-0.4,1.4l0.2,0l-0.1,0.3l-0.2,0l-0.2,0.5L163.8,69.1z  M164.2,67.7c0.1-0.2,0.1-0.4,0.2-0.5c-0.1,0.2-0.5,0.7-0.8,1l0.5-0.1L164.2,67.7z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M164.6,69l0.2-0.6l0.3,0l-0.2,0.6L164.6,69z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M183.4,76.9L158.8,79c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C183.6,76.7,183.5,76.8,183.4,76.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M159.9,77l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L159.9,77z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M162.4,74.9l-0.7,0.1c-0.1,0.1-0.2,0.4-0.2,0.5c0.1-0.1,0.2-0.2,0.3-0.2c0.3,0,0.4,0.3,0.3,0.7 c-0.1,0.4-0.4,0.9-0.8,0.9c-0.3,0-0.5-0.2-0.4-0.6l0.3,0c0,0.2,0,0.3,0.2,0.3c0.2,0,0.3-0.2,0.4-0.5c0.1-0.3,0.1-0.4-0.1-0.4 c-0.2,0-0.3,0.1-0.3,0.3l-0.3,0c0.1-0.3,0.4-1,0.5-1.3l1-0.1L162.4,74.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M162.3,76.8l0.2-0.6l0.3,0l-0.2,0.6L162.3,76.8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M181.1,84.6l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C181.3,84.5,181.2,84.6,181.1,84.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M157.6,84.7l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L157.6,84.7 z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M159.8,82.9c0-0.1,0-0.2-0.2-0.2c-0.2,0-0.4,0.3-0.5,0.7c0.1-0.1,0.3-0.3,0.4-0.3c0.3,0,0.4,0.3,0.3,0.7 c-0.1,0.5-0.5,0.9-0.8,0.9c-0.5,0.1-0.5-0.5-0.3-1.1c0.2-0.6,0.5-1.2,1-1.3c0.3,0,0.4,0.3,0.3,0.5L159.8,82.9z M159.5,83.8 c0.1-0.2,0.1-0.5-0.1-0.4c-0.2,0-0.3,0.2-0.4,0.5c-0.1,0.2-0.1,0.5,0.1,0.5C159.3,84.3,159.4,84.1,159.5,83.8z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M159.9,84.5l0.2-0.6l0.3,0l-0.2,0.6L159.9,84.5z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M178.8,92.3l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C179,92.2,178.9,92.3,178.8,92.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M155.3,92.5l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L155.3,92.5 z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M157.8,90.1l-0.1,0.3c-0.4,0.5-0.9,1.3-1.2,2h-0.3c0.3-0.7,0.8-1.5,1.2-1.9l-0.8,0.1l0.1-0.3L157.8,90.1z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M157.2,92.3l0.2-0.6l0.3,0l-0.2,0.6L157.2,92.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M176.4,100.1l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C176.7,100,176.6,100.1,176.4,100.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M153,100.2l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L153,100.2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M153.9,99.5c0.1-0.3,0.3-0.5,0.4-0.6c-0.1-0.1-0.1-0.2-0.1-0.5c0.1-0.4,0.4-0.6,0.7-0.7 c0.3,0,0.5,0.2,0.3,0.6c-0.1,0.3-0.2,0.4-0.3,0.5c0.1,0.1,0.2,0.2,0.1,0.5c-0.1,0.5-0.5,0.7-0.8,0.7 C154,100.2,153.8,99.9,153.9,99.5z M154.8,99.4c0.1-0.2,0-0.3-0.2-0.3c-0.2,0-0.3,0.2-0.4,0.4c-0.1,0.2,0,0.4,0.2,0.3 C154.6,99.8,154.8,99.7,154.8,99.4z M154.6,98.5c-0.1,0.2,0,0.3,0.2,0.3c0.2,0,0.3-0.1,0.3-0.3c0.1-0.2,0-0.3-0.2-0.3 C154.8,98.2,154.7,98.3,154.6,98.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M155.3,100l0.2-0.6l0.3,0l-0.2,0.6L155.3,100z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M174.1,107.8l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C174.4,107.7,174.2,107.8,174.1,107.8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M150.7,108l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L150.7,108z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M151.9,107.3c0,0.2,0,0.2,0.2,0.2c0.3,0,0.4-0.5,0.5-0.7c-0.1,0.2-0.3,0.2-0.4,0.2c-0.3,0-0.4-0.3-0.3-0.7 c0.1-0.4,0.4-0.8,0.8-0.8c0.4,0,0.4,0.4,0.3,1c-0.2,0.6-0.5,1.3-1,1.3c-0.4,0-0.4-0.3-0.4-0.5H151.9z M152.2,106.3 c-0.1,0.2,0,0.4,0.2,0.4c0.2,0,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.4-0.2-0.4C152.4,105.9,152.3,106.1,152.2,106.3z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M152.9,107.8l0.2-0.6l0.3,0l-0.2,0.6L152.9,107.8z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M171.8,115.6l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C172.1,115.5,171.9,115.6,171.8,115.6z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M148.1,115.8L148.1,115.8c0.1-0.4,0.3-0.7,0.8-1.1c0.3-0.3,0.4-0.3,0.5-0.6c0.1-0.2,0-0.3-0.1-0.3 c-0.2,0-0.3,0.2-0.4,0.4l-0.3,0c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.4,0.3,0.3,0.6c-0.1,0.3-0.2,0.5-0.6,0.8 c-0.3,0.2-0.4,0.4-0.5,0.5l0.8-0.1l-0.2,0.4L148.1,115.8z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M151.1,114.4c-0.2,0.6-0.5,1.2-1,1.2c-0.5,0.1-0.4-0.5-0.3-1.1c0.2-0.6,0.5-1.2,1-1.2 C151.3,113.2,151.3,113.7,151.1,114.4z M150.2,114.4c-0.1,0.4-0.2,0.8,0.1,0.8c0.2,0,0.4-0.4,0.5-0.9c0.1-0.4,0.2-0.8,0-0.8 C150.5,113.6,150.3,114,150.2,114.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M151.1,115.5l0.2-0.6l0.3,0l-0.2,0.6L151.1,115.5z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M169.5,123.3l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C169.7,123.2,169.6,123.3,169.5,123.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M145.7,123.5L145.7,123.5c0.1-0.4,0.3-0.7,0.8-1.1c0.3-0.3,0.4-0.3,0.5-0.6c0.1-0.2,0-0.3-0.1-0.3 c-0.2,0-0.3,0.2-0.4,0.4l-0.3,0c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.4,0.3,0.3,0.6c-0.1,0.3-0.2,0.5-0.6,0.8 c-0.3,0.2-0.4,0.4-0.5,0.5l0.8-0.1l-0.2,0.4L145.7,123.5z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M147.5,123.3l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3 L147.5,123.3z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M148.3,123.3l0.2-0.6l0.3,0l-0.2,0.6L148.3,123.3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.2,131.1l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C167.4,130.9,167.3,131.1,167.2,131.1z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M143.4,131.2L143.4,131.2c0.1-0.4,0.3-0.7,0.8-1.1c0.3-0.3,0.4-0.3,0.5-0.6c0.1-0.2,0-0.3-0.1-0.3 c-0.2,0-0.3,0.2-0.4,0.4l-0.3,0c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.4,0.3,0.3,0.6c-0.1,0.3-0.2,0.5-0.6,0.8 c-0.3,0.2-0.4,0.4-0.5,0.5l0.8-0.1l-0.2,0.4L143.4,131.2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M144.9,131.1L144.9,131.1c0.1-0.4,0.3-0.7,0.8-1.1c0.3-0.3,0.4-0.3,0.5-0.6c0.1-0.2,0-0.3-0.1-0.3 c-0.2,0-0.3,0.2-0.4,0.4l-0.3,0c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.4,0.3,0.3,0.6c-0.1,0.3-0.2,0.5-0.6,0.8 c-0.3,0.2-0.4,0.4-0.5,0.5l0.8-0.1l-0.2,0.4L144.9,131.1z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M146.5,131l0.2-0.6l0.3,0l-0.2,0.6L146.5,131z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M164.9,138.8l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C165.1,138.7,165,138.8,164.9,138.8z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M141.1,139L141.1,139c0.1-0.4,0.3-0.7,0.8-1.1c0.3-0.3,0.4-0.3,0.5-0.6c0.1-0.2,0-0.3-0.1-0.3 c-0.2,0-0.3,0.2-0.4,0.4l-0.3,0c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.4,0.3,0.3,0.6c-0.1,0.3-0.2,0.5-0.6,0.8 c-0.3,0.2-0.4,0.4-0.5,0.5l0.8-0.1l-0.2,0.4L141.1,139z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M143.1,137.2c0.1-0.3,0.3-0.6,0.7-0.7c0.4,0,0.4,0.2,0.3,0.6c-0.1,0.3-0.2,0.4-0.3,0.5 c0.1,0.1,0.2,0.2,0.1,0.5c-0.1,0.3-0.4,0.7-0.8,0.8c-0.4,0-0.5-0.3-0.4-0.6l0.3,0c0,0.2,0,0.3,0.2,0.3c0.2,0,0.3-0.2,0.4-0.4 c0.1-0.2,0-0.4-0.2-0.3h-0.1l0.1-0.3h0.1c0.2,0,0.3-0.1,0.3-0.3c0.1-0.2,0-0.3-0.2-0.3c-0.2,0-0.3,0.2-0.3,0.3L143.1,137.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M144.1,138.7l0.2-0.6l0.3,0l-0.2,0.6L144.1,138.7z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M161.3,146.6l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C161.6,146.5,161.4,146.6,161.3,146.6z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M137.6,146.8L137.6,146.8c0.1-0.4,0.3-0.7,0.8-1.1c0.3-0.3,0.4-0.3,0.5-0.6c0.1-0.2,0-0.3-0.1-0.3 c-0.2,0-0.3,0.2-0.4,0.4l-0.3,0c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.4,0.3,0.3,0.6c-0.1,0.3-0.2,0.5-0.6,0.8 c-0.3,0.2-0.4,0.4-0.5,0.5l0.8-0.1l-0.2,0.4L137.6,146.8z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M139.8,146.6l0.2-0.5l-0.7,0.1l0.1-0.4l1.1-1.4l0.3,0l-0.4,1.4l0.2,0l-0.1,0.3l-0.2,0l-0.2,0.5 L139.8,146.6z M140.2,145.3c0.1-0.2,0.1-0.4,0.2-0.5c-0.1,0.2-0.5,0.7-0.8,1l0.5-0.1L140.2,145.3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M140.6,146.5l0.2-0.6l0.3,0l-0.2,0.6L140.6,146.5z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.9,71.6l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C157.2,71.5,157.1,71.6,156.9,71.6z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M132.7,71.8L132.7,71.8c0.1-0.4,0.3-0.7,0.8-1.1c0.3-0.3,0.4-0.3,0.5-0.6c0.1-0.2,0-0.3-0.1-0.3 c-0.2,0-0.3,0.2-0.4,0.4l-0.3,0c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.4,0.3,0.3,0.6c-0.1,0.3-0.2,0.5-0.6,0.8 c-0.3,0.2-0.4,0.4-0.5,0.5l0.8-0.1l-0.2,0.4L132.7,71.8z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M134.3,71.7l0.2-0.6l0.3,0l-0.2,0.6L134.3,71.7z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M154.6,79.4L130,81.5c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C154.8,79.3,154.7,79.4,154.6,79.4z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M130.9,77.9c0.1-0.3,0.3-0.6,0.7-0.7c0.4,0,0.4,0.2,0.3,0.6c-0.1,0.3-0.2,0.4-0.3,0.5 c0.1,0.1,0.2,0.2,0.1,0.5c-0.1,0.3-0.4,0.7-0.8,0.8c-0.4,0-0.5-0.3-0.4-0.6l0.3,0c0,0.2,0,0.3,0.2,0.3c0.2,0,0.3-0.2,0.4-0.4 c0.1-0.2,0-0.4-0.2-0.3h-0.1l0.1-0.3h0.1c0.2,0,0.3-0.1,0.3-0.3c0.1-0.2,0-0.3-0.2-0.3c-0.2,0-0.3,0.2-0.3,0.3L130.9,77.9z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M132,79.4l0.2-0.6l0.3,0l-0.2,0.6L132,79.4z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M152.3,87.1l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C152.5,87,152.4,87.1,152.3,87.1z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M128.8,87.3l0.2-0.5l-0.7,0.1l0.1-0.4l1.1-1.4l0.3,0l-0.4,1.4l0.2,0l-0.1,0.3l-0.2,0l-0.2,0.5L128.8,87.3z  M129.2,85.9c0.1-0.2,0.1-0.4,0.2-0.5c-0.1,0.2-0.5,0.7-0.8,1l0.5-0.1L129.2,85.9z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M129.7,87.2l0.2-0.6l0.3,0l-0.2,0.6L129.7,87.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M150,94.9L125.4,97c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C150.2,94.7,150.1,94.9,150,94.9z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M127.5,93.1l-0.7,0.1c-0.1,0.1-0.2,0.4-0.2,0.5c0.1-0.1,0.2-0.2,0.3-0.2c0.3,0,0.4,0.3,0.3,0.7 c-0.1,0.4-0.4,0.9-0.8,0.9c-0.3,0-0.5-0.2-0.4-0.6l0.3,0c0,0.2,0,0.3,0.2,0.3c0.2,0,0.3-0.2,0.4-0.5c0.1-0.3,0.1-0.4-0.1-0.4 c-0.2,0-0.3,0.1-0.3,0.3l-0.3,0c0.1-0.3,0.4-1,0.5-1.3l1-0.1L127.5,93.1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M127.3,94.9l0.2-0.6l0.3,0l-0.2,0.6L127.3,94.9z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M147.7,102.6l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C147.9,102.5,147.8,102.6,147.7,102.6z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M124.8,101c0-0.1,0-0.2-0.2-0.2c-0.2,0-0.4,0.3-0.5,0.7c0.1-0.1,0.3-0.3,0.4-0.3c0.3,0,0.4,0.3,0.3,0.7 c-0.1,0.5-0.5,0.9-0.8,0.9c-0.5,0.1-0.5-0.5-0.3-1.1c0.2-0.6,0.5-1.2,1-1.3c0.3,0,0.4,0.3,0.3,0.5L124.8,101z M124.6,102 c0.1-0.2,0.1-0.5-0.1-0.4c-0.2,0-0.3,0.2-0.4,0.5c-0.1,0.2-0.1,0.5,0.1,0.5C124.4,102.4,124.5,102.2,124.6,102z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M125,102.7l0.2-0.6l0.3,0l-0.2,0.6L125,102.7z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M145.3,110.4l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C145.6,110.3,145.4,110.4,145.3,110.4z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M123.1,108.2l-0.1,0.3c-0.4,0.5-0.9,1.3-1.2,2l-0.3,0c0.3-0.7,0.8-1.5,1.2-1.9l-0.8,0.1l0.1-0.3 L123.1,108.2z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M122.5,110.5l0.2-0.6l0.3,0l-0.2,0.6L122.5,110.5z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M143,118.2l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C143.3,118,143.1,118.2,143,118.2z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119,117.7c0.1-0.3,0.3-0.5,0.4-0.6c-0.1-0.1-0.1-0.2-0.1-0.5c0.1-0.4,0.4-0.6,0.7-0.7 c0.3,0,0.5,0.2,0.3,0.6c-0.1,0.3-0.2,0.4-0.3,0.5c0.1,0.1,0.2,0.2,0.1,0.5c-0.1,0.5-0.5,0.7-0.8,0.7 C119.1,118.4,118.9,118.1,119,117.7z M119.9,117.6c0.1-0.2,0-0.3-0.2-0.3c-0.2,0-0.3,0.2-0.4,0.4c-0.1,0.2,0,0.4,0.2,0.3 C119.7,118,119.9,117.9,119.9,117.6z M119.7,116.7c-0.1,0.2,0,0.3,0.2,0.3c0.2,0,0.3-0.1,0.3-0.3c0.1-0.2,0-0.3-0.2-0.3 S119.7,116.5,119.7,116.7z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M120.4,118.2l0.2-0.6l0.3,0l-0.2,0.6L120.4,118.2z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M140.7,125.9l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C140.9,125.8,140.8,125.9,140.7,125.9z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M117,125.5c0,0.2,0,0.2,0.2,0.2c0.3,0,0.4-0.5,0.5-0.7c-0.1,0.2-0.3,0.2-0.4,0.2c-0.3,0-0.4-0.3-0.3-0.7 c0.1-0.4,0.4-0.8,0.8-0.8c0.4,0,0.4,0.4,0.3,1c-0.2,0.6-0.5,1.3-1,1.3c-0.4,0-0.4-0.3-0.4-0.5H117z M117.3,124.5 c-0.1,0.2,0,0.4,0.2,0.4c0.2,0,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.4-0.2-0.4C117.5,124.1,117.4,124.3,117.3,124.5z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118.1,126l0.2-0.6l0.3,0l-0.2,0.6L118.1,126z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M138.5,133.6l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C138.7,133.5,138.6,133.6,138.5,133.6z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M114.7,133.8l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3 L114.7,133.8z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M117.1,132.5c-0.2,0.6-0.5,1.2-1,1.2c-0.5,0.1-0.4-0.5-0.3-1.1c0.2-0.6,0.5-1.2,1-1.2 C117.3,131.3,117.3,131.9,117.1,132.5z M116.2,132.6c-0.1,0.4-0.2,0.8,0.1,0.8c0.2,0,0.4-0.4,0.5-0.9c0.1-0.4,0.2-0.8,0-0.8 C116.5,131.7,116.3,132.1,116.2,132.6z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M117,133.6l0.2-0.6l0.3,0l-0.2,0.6L117,133.6z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.2,141.4l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C136.4,141.3,136.3,141.4,136.2,141.4z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M112.4,141.6l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3 L112.4,141.6z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.4,141.5l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3 L113.4,141.5z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M114.2,141.4l0.2-0.6l0.3,0l-0.2,0.6L114.2,141.4z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M132.6,149.2l-24.6,2.2c-0.1,0-0.2-0.1-0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.3l24.6-2.2c0.1,0,0.2,0.1,0.1,0.2 C132.8,149.1,132.7,149.2,132.6,149.2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M109,149.4l0.5-1.8c-0.1,0.1-0.3,0.1-0.3,0.2l0.1-0.3c0.2-0.1,0.3-0.2,0.5-0.3l0.2,0l-0.7,2.3L109,149.4z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M109.8,149.3L109.8,149.3c0.1-0.4,0.3-0.7,0.8-1.1c0.3-0.3,0.4-0.3,0.5-0.6c0.1-0.2,0-0.3-0.1-0.3 c-0.2,0-0.3,0.2-0.4,0.4l-0.3,0c0.1-0.4,0.4-0.7,0.8-0.7c0.4,0,0.4,0.3,0.3,0.6c-0.1,0.3-0.2,0.5-0.6,0.8 c-0.3,0.2-0.4,0.4-0.5,0.5l0.8-0.1l-0.2,0.4L109.8,149.3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M111.3,149.2l0.2-0.6l0.3,0l-0.2,0.6L111.3,149.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.5,62L140,63.3l0.2-1.6l16.5-1.3L156.5,62z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M154.2,69.8l-16.5,1.3l0.2-1.6l16.5-1.3L154.2,69.8z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M151.9,77.7L135.4,79l0.2-1.6l16.6-1.3L151.9,77.7z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M149.7,85.5l-16.6,1.3l0.2-1.6l16.5-1.3L149.7,85.5z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M147.4,93.4l-16.6,1.3L131,93l16.5-1.3L147.4,93.4z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M145.1,101.2l-16.5,1.3l0.2-1.6l16.5-1.3L145.1,101.2z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M142.8,109l-16.5,1.3l0.2-1.6l16.6-1.3L142.8,109z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M140.5,116.8l-16.6,1.3l0.2-1.6l16.6-1.3L140.5,116.8z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M138.2,124.7l-16.6,1.3l0.2-1.6l16.5-1.3L138.2,124.7z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M135.9,132.5l-16.5,1.3l0.2-1.6l16.5-1.3L135.9,132.5z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M133.6,139.7l-16.6,1.3l0.2-1.6l16.6-1.3L133.6,139.7z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M130.4,147.9l-16.5,1.3l0.2-1.6l16.6-1.3L130.4,147.9z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M186.1,59.2l-16.6,1.3l0.2-1.6l16.5-1.3L186.1,59.2z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M183.8,67.1l-16.5,1.3l0.2-1.6l16.5-1.3L183.8,67.1z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M181.5,74.9L165,76.2l0.2-1.6l16.5-1.3L181.5,74.9z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M179.2,82.7l-16.5,1.3l0.2-1.6l16.6-1.3L179.2,82.7z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M176.9,90.6l-16.6,1.3l0.2-1.6l16.6-1.3L176.9,90.6z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M174.7,98.4l-16.6,1.3l0.2-1.6l16.5-1.3L174.7,98.4z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.3,106.2l-16.5,1.3l0.2-1.6l16.5-1.3L172.3,106.2z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M170.1,114.1l-16.5,1.3l0.2-1.6l16.6-1.3L170.1,114.1z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.8,121.9l-16.6,1.3l0.2-1.6l16.6-1.3L167.8,121.9z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M165.5,129.7l-16.6,1.3l0.2-1.6l16.5-1.3L165.5,129.7z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M163.1,137l-16.5,1.3l0.2-1.6l16.6-1.3L163.1,137z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M159.9,145.2l-16.5,1.3l0.2-1.6l16.5-1.3L159.9,145.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012451223663488625820000010863485712009737875_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.1792,
    y1: 140.117,
    x2: 191.8532,
    y2: 177.9073,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    style: {
      stopColor: "#89ABFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#759DF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7421,
    style: {
      stopColor: "#5487EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3370E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000012451223663488625820000010863485712009737875_)",
      enableBackground: "new"
    },
    d: " M172.3,19.6h-2.6v2.6h2.6V19.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026852997833445777360000009960357793414289586_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.9492,
    y1: 142.87,
    x2: 189.6241,
    y2: 180.6603,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    style: {
      stopColor: "#89ABFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#759DF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7421,
    style: {
      stopColor: "#5487EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3370E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000026852997833445777360000009960357793414289586_)",
      enableBackground: "new"
    },
    d: " M172.3,15.1h-2.6v2.6h2.6V15.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065753295010596812520000013184158753196518038_",
    gradientUnits: "userSpaceOnUse",
    x1: 140.7199,
    y1: 145.6237,
    x2: 187.3949,
    y2: 183.414,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    style: {
      stopColor: "#89ABFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#759DF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7421,
    style: {
      stopColor: "#5487EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3370E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000065753295010596812520000013184158753196518038_)",
      enableBackground: "new"
    },
    d: " M172.3,10.5h-2.6v2.6h2.6V10.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000138551662263049237140000017192966487402383032_",
    cx: -290.2712,
    cy: 514.5582,
    r: 1,
    gradientTransform: "matrix(-29.0146 15.495 8.1537 15.268 -12498.582 -3240.8906)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BFCCD2",
      stopOpacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2154,
    style: {
      stopColor: "#97BAC1",
      stopOpacity: 0.5492
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4317,
    style: {
      stopColor: "#76ABB2",
      stopOpacity: 0.3978
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6397,
    style: {
      stopColor: "#5FA0A8",
      stopOpacity: 0.2522
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8338,
    style: {
      stopColor: "#5199A2",
      stopOpacity: 0.1164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C97A0",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138551662263049237140000017192966487402383032_)"
    },
    d: "M156.2,91.4c0,0,1.9,1-1,6.3 c-2.9,5.3-18.5,33.6-23.8,35.7c-5.4,2.1-51.5,10-54.2,1.4c-2.7-8.6,28.1-32,32.9-34.5C114.9,97.7,156.2,91.4,156.2,91.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047036595426296944120000010717153563085864354_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.579,
    y1: 103.8321,
    x2: 70.579,
    y2: 118.6789,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#132534"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4606,
    style: {
      stopColor: "#314462"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#586B9D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047036595426296944120000010717153563085864354_)"
    },
    d: "M69.8,77.6L65,70.9h2.3v-3.7 c0-2.7,2.2-5,4.9-5h3.9c-2.3,0-3.9,1.6-3.9,4.6v4.1h2.3L69.8,77.6z"
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M121.2,101.8l-10.3,4c-0.2,0.1-0.3,0-0.4-0.2l-0.1-0.3c-0.1-0.2,0-0.3,0.2-0.4l10.3-4 c0.2-0.1,0.3,0,0.4,0.2l0.1,0.3C121.4,101.6,121.4,101.7,121.2,101.8z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M117.1,103.4l-14.4,5.6c-0.3,0.1-0.5,0-0.6-0.3c-0.1-0.3,0-0.5,0.3-0.6l14.4-5.6c0.3-0.1,0.5,0,0.6,0.3 C117.5,103,117.3,103.3,117.1,103.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060028600075758536770000009686915464142025606_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.3048,
    y1: 42.7664,
    x2: 10.2681,
    y2: -14.7966,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    style: {
      stopColor: "#89ABFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#759DF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7421,
    style: {
      stopColor: "#5487EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3370E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000060028600075758536770000009686915464142025606_)",
      enableBackground: "new"
    },
    d: " M49.4,147.2h-3.7v3.7h3.7V147.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094591497078261529010000013455021490914089122_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.3968,
    y1: 40.3472,
    x2: 13.3596,
    y2: -17.2158,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    style: {
      stopColor: "#89ABFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#759DF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7421,
    style: {
      stopColor: "#5487EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3370E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000094591497078261529010000013455021490914089122_)",
      enableBackground: "new"
    },
    d: " M49.4,153.6h-3.7v3.7h3.7V153.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044160681345242303610000001610919546862899876_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.476,
    y1: 37.938,
    x2: 16.4393,
    y2: -19.625,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    style: {
      stopColor: "#89ABFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#759DF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7421,
    style: {
      stopColor: "#5487EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3370E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000044160681345242303610000001610919546862899876_)",
      enableBackground: "new"
    },
    d: " M49.4,159.9h-3.7v3.7h3.7V159.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010269099608389292290000003390742557150108847_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.5548,
    y1: 35.5291,
    x2: 19.5179,
    y2: -22.0339,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#90B0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    style: {
      stopColor: "#89ABFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4326,
    style: {
      stopColor: "#759DF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7421,
    style: {
      stopColor: "#5487EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3370E4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000010269099608389292290000003390742557150108847_)",
      enableBackground: "new"
    },
    d: " M49.4,166.3h-3.7v3.7h3.7V166.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031176960594236313500000014028455696918584511_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.16,
    y1: 109.5074,
    x2: 106.455,
    y2: 73.7184,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#687B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    style: {
      stopColor: "#5F738F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6786,
    style: {
      stopColor: "#41576B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#364C5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031176960594236313500000014028455696918584511_)"
    },
    d: "M142.9,101.5l-30.1,11.9L93.7,121 l-2.5,1l0,0l-1.4,0.6c0,0,0,0,0,0l-1.7,0.7l-5.2,2.1l-0.2,0.1c-0.2,0.1-0.4,0.1-0.6,0c-0.1,0-0.2-0.1-0.3-0.2l0,0l-10.4-12.6 l15.6-6.2l44.8-17.7l0.4-0.2c0.7-0.3,1.4-0.1,1.9,0.5c0,0,8.9,10.8,9.4,11.4c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.2 c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1s0,0.1-0.1,0.1c0,0,0,0.1-0.1,0.1C143.3,101.3,143.1,101.5,142.9,101.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055706339571001084740000013169326773209880255_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.8393,
    y1: 56.6942,
    x2: 82.5605,
    y2: 56.6452,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#475B80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6559,
    style: {
      stopColor: "#2C3D51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21313E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055706339571001084740000013169326773209880255_)"
    },
    d: "M82.8,125.3c-0.1,0-0.1,0-0.1,0.1 c0,0-0.1,0-0.1,0L82.8,125.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092440174532990726910000002645030171747982511_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.5041,
    y1: 63.3797,
    x2: 82.2898,
    y2: 63.4347,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#475B80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6559,
    style: {
      stopColor: "#2C3D51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21313E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092440174532990726910000002645030171747982511_)"
    },
    d: "M143,107.2L83.4,132c0,0-0.1,0-0.1,0 c-0.2,0.1-0.4,0.1-0.6,0l-0.1-1.5l-0.4-5l-0.4-0.5c0,0,0,0,0,0c0.1,0.1,0.2,0.2,0.3,0.2c0.2,0.1,0.4,0.1,0.6,0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0,0,0,0l5.2-2.1l1.7-0.7c0,0,0,0,0,0l1.4-0.6h0l2.5-1l49.3-19.5c0.2-0.1,0.4-0.2,0.5-0.4 c0,0,0.1-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l0.3,5C144,106.3,143.6,107,143,107.2z "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000093176037655801816120000018208045575654132107_",
    cx: -234.1124,
    cy: 494.1285,
    r: 1,
    gradientTransform: "matrix(5.0642 6.1414 6.1268 -5.0521 -1764.9608 4056.5337)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#687B99"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5133,
    style: {
      stopColor: "#55688A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#475B80"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093176037655801816120000018208045575654132107_)"
    },
    d: "M82.6,132.1c-0.1,0-0.2-0.1-0.3-0.2 l-0.1-0.1l-2.4-3l-1.2-1.4l-4.3-5.4l-0.1-0.1l-0.6-0.7l-1.9-2.3l-0.4-6.1l10.7,13l0.4,5L82.6,132.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005946203692262729660000001215709073919912367_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.2523,
    y1: 121.2635,
    x2: 83.0775,
    y2: 43.8308,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3656,
    style: {
      stopColor: "#F7F9FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6725,
    style: {
      stopColor: "#E0E9F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0D2E1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005946203692262729660000001215709073919912367_)"
    },
    d: "M88.3,122.4c-1.2,0.2-2.5,0.3-3.6,0.1 v0l-11.4-1.6l-41.6-5.8l-4.7-0.7c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.2-0.3-0.5-0.2-0.8l0.1-0.2l6.4-13l0.1-0.2 c0.3-0.7,1.1-1.1,1.9-1l50.6,7.1c5.8,0.5,10.9,1.8,11.7,6.3v0c0.3,1.8-0.2,3.6-1.2,5.1C94.4,120,91.6,121.8,88.3,122.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145765942745783581840000002561666978934800770_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.4233,
    y1: 85.2725,
    x2: 78.7002,
    y2: 48.3093,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#475B80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6559,
    style: {
      stopColor: "#2C3D51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#21313E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000145765942745783581840000002561666978934800770_)",
      enableBackground: "new"
    },
    d: " M93.7,121l-5.7,2.3c-1.1,0.2-2.1,0.2-3.1,0.1v0l-5.2-0.7l-6.2-0.9L31.8,116l-4.7-0.7c-0.4-0.1-0.7-0.5-0.5-0.9 c0.1,0.1,0.2,0.1,0.3,0.1l4.7,0.7l41.6,5.8l5.7,0.8l5.7,0.8v0c1.2,0.1,2.4,0.1,3.6-0.1c3.4-0.6,6.2-2.4,7.7-4.7 c1-1.5,1.5-3.3,1.2-5.1c0.1,0.2,0.1,0.5,0.2,0.7c0.3,1.8-0.2,3.6-1.2,5.2C95.5,119.4,94.7,120.3,93.7,121z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165914039760935091760000016122976229561883568_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.4587,
    y1: 62.1505,
    x2: 60.5816,
    y2: 63.0575,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8598B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1225,
    style: {
      stopColor: "#92A4BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#B7C5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    style: {
      stopColor: "#CEDAE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6E1E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165914039760935091760000016122976229561883568_)"
    },
    d: "M87.9,123c-1.2,0.2-2.5,0.3-3.6,0.1v0 l-10.2-1.4l-1.3-0.2l-41.6-5.8l-0.3-0.1l-4.4-0.6c-0.2,0-0.4-0.2-0.5-0.4c0-0.3,0.1-0.5,0.1-0.7c0,0,0,0,0,0l0.2-0.3l6.3-12.8 c0.1-0.1,0.2-0.3,0.3-0.4l-6.4,13l-0.1,0.2c-0.2,0.4,0.1,0.9,0.5,0.9l4.7,0.7l41.6,5.8l11.4,1.6v0c1.2,0.1,2.4,0.1,3.6-0.1 c3.4-0.6,6.2-2.4,7.7-4.7C94.5,120.3,91.6,122.4,87.9,123z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143581834996385710490000005841097200507912855_",
    gradientUnits: "userSpaceOnUse",
    x1: 31.762,
    y1: 64.6449,
    x2: 22.1873,
    y2: 63.5629,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8598B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3943,
    style: {
      stopColor: "#66799B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7649,
    style: {
      stopColor: "#4F6387"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#475B80"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143581834996385710490000005841097200507912855_)"
    },
    d: "M27.4,121.1c-0.3-0.3-0.4-0.5-0.4-0.5 s-1-4.5-1-5.8c0,0,0-0.1,0-0.1c0.1,0.2,0.3,0.4,0.5,0.4l4.4,0.6L27.4,121.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162343918677131389380000002002716298913353372_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.6724,
    y1: 46.1656,
    x2: 74.5316,
    y2: 86.7846,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7C889D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1864,
    style: {
      stopColor: "#929EB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5363,
    style: {
      stopColor: "#B7C2CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#CED9E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6E1E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162343918677131389380000002002716298913353372_)"
    },
    d: "M79.8,128.7c0,0-50-6.9-51.2-7.1 c-0.5-0.1-0.9-0.3-1.1-0.5l3.4-5.4l0.3,0.1l41.6,5.8l1.4,0.2L79.8,128.7z"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.6,
    y: 108.6,
    className: "st32",
    width: 12.9,
    height: 10.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007409467016297419450000007405609446392259228_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.6576,
    y1: 71.3347,
    x2: 108.4439,
    y2: 65.8827,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8598B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1225,
    style: {
      stopColor: "#92A4BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#B7C5D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    style: {
      stopColor: "#CEDAE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6E1E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007409467016297419450000007405609446392259228_)"
    },
    d: "M88.7,118.4c-3.1,1.3-6.3,0.4-7.3-2 c-1-2.4,0.7-5.4,3.8-6.7c3.1-1.3,6.3-0.4,7.3,2C93.5,114.1,91.8,117.1,88.7,118.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031180420752332746910000009499224993551888004_",
    gradientUnits: "userSpaceOnUse",
    x1: 133.7899,
    y1: 85.5576,
    x2: 122.8169,
    y2: 81.4901,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28394C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7981,
    style: {
      stopColor: "#5F7398"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031180420752332746910000009499224993551888004_)"
    },
    d: "M133.3,100.9c-2.3,1.1-5.3,0.6-6.8-1.2 c-1.5-1.8-0.8-4.2,1.4-5.3c2.3-1.1,5.3-0.6,6.8,1.2C136.2,97.4,135.5,99.8,133.3,100.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173883670832913051560000012050303434077214101_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.9742,
    y1: 83.3126,
    x2: 140.4842,
    y2: 85.5471,
    gradientTransform: "matrix(1 0 0 -1 0 182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#556A81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308,
    style: {
      stopColor: "#455B6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6534,
    style: {
      stopColor: "#3A5062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9671,
    style: {
      stopColor: "#364C5D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173883670832913051560000012050303434077214101_)"
    },
    d: "M133.2,100.7c-2.2,1.1-5.1,0.6-6.5-1.2 c-1.4-1.7-0.8-4,1.4-5.1c2.2-1.1,5.1-0.6,6.5,1.2C136,97.4,135.4,99.6,133.2,100.7z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009562502351082092200000002906601109811726485_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.3545,
    y1: 152.1471,
    x2: 75.017,
    y2: 142.9774,
    gradientTransform: "matrix(0.7534 0.6576 -0.6576 0.7534 86.6211 -53.4329)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01154727,
    style: {
      stopColor: "#8099A8",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7872,
    style: {
      stopColor: "#A3B7C4",
      stopOpacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009562502351082092200000002906601109811726485_)"
    },
    d: "M54.4,113.6l-0.2,0.5l3.6,0.5l1-2.3 l-0.5-0.1l-0.8,1.8L54.4,113.6z M57.7,106.1l-0.2,0.5l3.1,0.4l-0.8,1.8l0.5,0.1l1-2.3L57.7,106.1z M54.1,109.7l0.5-1.2l0.8,0.1 c0.4,0.1,0.5,0.2,0.3,0.6l-0.1,0.2c-0.2,0.4-0.4,0.5-0.8,0.4L54.1,109.7z M55.3,110.1c0.4,0,0.8-0.3,1-0.7c0.1-0.3,0.1-0.5,0-0.7 c-0.1-0.3-0.4-0.4-0.8-0.5l-1.2-0.2l-1.5,3.4l0.5,0.1l0.6-1.4l0.8,0.1c0.4,0.1,0.5,0.2,0.3,0.6l-0.4,0.8l0.5,0.1l0.3-0.7 C55.7,110.5,55.7,110.3,55.3,110.1L55.3,110.1z M50.9,109.6l1.6,0.2l0.2-0.5l-1.6-0.2l0.5-1l1.7,0.2l0.2-0.5l-2.3-0.3l-1.5,3.4 l2.3,0.3l0.2-0.5l-1.8-0.3L50.9,109.6z M49.2,109.6l-0.1,0.2c-0.2,0.5-0.5,0.6-1,0.6l-0.1,0c-0.5-0.1-0.6-0.2-0.3-0.9l0.4-0.9 c0.3-0.7,0.6-0.8,1.1-0.7l0.1,0c0.5,0.1,0.5,0.3,0.3,0.7l0.6,0.1c0.2-0.7,0-1.2-0.7-1.3c-0.3,0-0.7,0-1,0.2 c-0.5,0.2-0.8,0.7-1.2,1.4c-0.3,0.7-0.4,1.2-0.2,1.5c0.1,0.2,0.4,0.4,0.7,0.4c0.3,0,0.6,0,0.9-0.3l0.1,0l-0.1,0.3l0.5,0.1l0.8-1.8 l-1.4-0.2l-0.2,0.5L49.2,109.6z M45.4,107.3l0.6,0.1c0.5,0.1,0.8,0.2,0.5,0.9l-0.4,0.9c-0.3,0.7-0.6,0.8-1.2,0.7l-0.6-0.1 L45.4,107.3z M44.7,110.4c1,0.1,1.7-0.5,2.1-1.5c0.5-1,0.4-1.8-0.6-1.9l-1.1-0.2l-1.5,3.4L44.7,110.4L44.7,110.4z M41.7,108.4 l1.6,0.2l0.2-0.5l-1.6-0.2l0.5-1l1.7,0.2l0.2-0.5l-2.3-0.3l-1.5,3.4l2.3,0.3l0.2-0.5l-1.8-0.3L41.7,108.4z M39.6,106l-0.5-0.1 l-1.5,3.4l2.4,0.3l0.2-0.5l-1.8-0.3L39.6,106z M33.9,108.9l-1,2.3l3.6,0.5l0.2-0.5l-3.1-0.4l0.8-1.8L33.9,108.9z M36.5,103.2l-1,2.3 l0.5,0.1l0.8-1.8l3.1,0.4l0.2-0.5L36.5,103.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecovery);
export default __webpack_public_path__ + "static/media/recovery.9db826d68f28cc925eb15f4a5aa17bb7.svg";
export { ForwardRef as ReactComponent };